<p-dialog
  header="Detalle de transacción"
  [(visible)]="menuService.modalDetalleTransaccionVisible"
  [breakpoints]="{ '7680px': '30vw', '1920px': '50vw', '1024px': '70vw', '450px': '90vw' }"
  [style]="{ width: '60vw' }"
  [draggable]="false"
  [modal]="true"
  [styleClass]="'rounded-md'"
  (onHide)="closeDialog()"
  [resizable]="false">
  @if(transaccionService.statePlaceToPayData()?.loading){
    <div class="flex flex-col items-center mb-2">
      <p>
        <p-skeleton shape="circle" size="4rem" styleClass="mr-2 mb-1" />
      </p>
      <p class="text-xl font-semibold text-gree">
        <p-skeleton width="10rem" styleClass="m-1" />
      </p>
    </div>
    <div class="flow-root px-5 py-3 pb-6 sm:col-span-6">
      <dl class="-my-3 divide-y divide-gray-100 text-sm">
        <div class="grid grid-cols-1 gap-1 py-1 sm:grid-cols-3 sm:gap-4" *ngFor="let i of [].constructor(8); let j = index">
          <dt class="font-medium text-gray-900"><p-skeleton styleClass="m-1" /></dt>
          <dd class="text-right text-gray-700 sm:col-span-2">
            <p-skeleton  styleClass="m-1" />
          </dd>
        </div>
      </dl>
    </div>
  } @else if(transaccionService.statePlaceToPayData()?.data?.requestId){
  <div class="flex flex-col items-center">
    <p>
      <i [className]="estadosTransaccionIcon(this.transaccionService.statePlaceToPayData().data?.status.status)" style="font-size: 2.5rem;" [style]="estadosTransaccionColor(this.transaccionService.statePlaceToPayData().data?.status.status)"></i>
    </p>
    <p class="text-xl font-semibold text-gree" [style]="estadosTransaccionColor(this.transaccionService.statePlaceToPayData().data?.status.status)">
      @if (transaccionService.statePlaceToPayData().data?.request.subscription) {
        @if (this.transaccionService.statePlaceToPayData().data?.status.status === 'APPROVED') {
          Suscripción aprobada
        } @else if(this.transaccionService.statePlaceToPayData().data?.status.status === 'PENDING') {
          Suscripción pendiente
        } @else {
          Suscripción rechazada
        }
      } @else {
        {{ 
          estadosTransaccion(this.transaccionService.statePlaceToPayData().data?.status.status)
        }}
      }
    </p>
  </div>
  <!--  -->
  <div class="grid grid-cols-1 gap-1 py-1 sm:grid-cols-1 sm:gap-4">
    <dt class="font-medium text-gray-900">Resumen de pago</dt>
  </div>
  <!--  -->
  <div class="flow-root px-5 py-3 pb-6 sm:col-span-6">
    <dl class="-my-3 divide-y divide-gray-100 text-sm">
      <div class="grid grid-cols-1 gap-1 py-1 sm:grid-cols-3 sm:gap-4">
        <dt class="font-medium text-gray-900">Fecha hora</dt>
        <dd class="text-right text-gray-700 sm:col-span-2">
          {{ transaccionService.statePlaceToPayData().data?.status?.date | date: 'dd/MM/yyyy hh:mm a' }}
        </dd>
      </div>

      <div class="grid grid-cols-1 gap-1 py-1 sm:grid-cols-3 sm:gap-4">
        <dt class="font-medium text-gray-900">Número de referencia</dt>
        <dd class="text-right text-gray-700 sm:col-span-2">
          {{ transaccionService.statePlaceToPayData().data?.request.payment
            ? transaccionService.statePlaceToPayData().data?.request.payment.reference 
            : transaccionService.statePlaceToPayData().data?.request.subscription.reference
          }}
        </dd>
      </div>

      @if (this.transaccionService.statePlaceToPayData().data?.status.status !== 'APPROVED') {
        <div class="grid grid-cols-1 gap-1 py-1 sm:grid-cols-3 sm:gap-4">
          <dt class="font-medium text-gray-900">Motivo</dt>
          <dd class="text-right text-gray-700 sm:col-span-2">
            {{ this.transaccionService.statePlaceToPayData().data?.status.reason }} -
            {{ this.transaccionService.statePlaceToPayData().data?.status.message }}
          </dd>
        </div> 
      }

      @if (transaccionService.statePlaceToPayData().data?.payment || transaccionService.statePlaceToPayData().data?.subscription) {
        <div class="grid grid-cols-1 gap-1 py-1 sm:grid-cols-3 sm:gap-4">
          <dt class="font-medium text-gray-900">Banco</dt>
          <dd class="text-right text-gray-700 sm:col-span-2">
            {{
              transaccionService.statePlaceToPayData().data?.payment
                ? transaccionService.statePlaceToPayData().data?.payment[transaccionService.statePlaceToPayData().data?.payment.length - 1]?.issuerName
                : transaccionService.statePlaceToPayData().data?.subscription?.instrument
                ? transaccionService.statePlaceToPayData().data?.subscription?.instrument[4]?.value
                : ''
            }}
          </dd>
        </div>
  
        <div class="grid grid-cols-1 gap-1 py-1 sm:grid-cols-3 sm:gap-4">
          <dt class="font-medium text-gray-900">Franquicia</dt>
          <dd class="text-right capitalize text-gray-700 sm:col-span-2">
            {{
              transaccionService.statePlaceToPayData().data?.payment
                ? transaccionService.statePlaceToPayData().data?.payment[transaccionService.statePlaceToPayData().data?.payment.length - 1]?.paymentMethod
                : transaccionService.statePlaceToPayData().data?.subscription?.instrument
                ? transaccionService.statePlaceToPayData().data?.subscription?.instrument[3]?.value
                : ''
            }}
          </dd>
        </div>
  
        <div class="grid grid-cols-1 gap-1 py-1 sm:grid-cols-3 sm:gap-4">
          <dt class="font-medium text-gray-900">Últimos dígitos tarjeta</dt>
          <dd class="text-right capitalize text-gray-700 sm:col-span-2">
            {{
              transaccionService.statePlaceToPayData().data?.payment
                ? getValueByKeyWord(transaccionService.statePlaceToPayData().data?.payment[transaccionService.statePlaceToPayData().data?.payment.length - 1]?.processorFields)
                : transaccionService.statePlaceToPayData().data?.subscription?.instrument
                ? transaccionService.statePlaceToPayData().data?.subscription?.instrument[5]?.value
                : ''
            }}
          </dd>
        </div>
        }

      @if (this.transaccionService.statePlaceToPayData().data?.status.reason !== '?C') {
        @if (transaccionService.statePlaceToPayData().data?.payment) {
          <div class="grid grid-cols-1 gap-1 py-1 sm:grid-cols-3 sm:gap-4">
            <dt class="font-medium text-gray-900">Recibo</dt>
            <dd class="text-right text-gray-700 sm:col-span-2">
              {{
                transaccionService.statePlaceToPayData().data?.payment
                  ? transaccionService.statePlaceToPayData().data?.payment[transaccionService.statePlaceToPayData().data?.payment.length - 1].receipt
                  : ''
              }}
            </dd>
          </div>
        }

        <div class="grid grid-cols-1 gap-1 py-1 sm:grid-cols-3 sm:gap-4">
          <dt class="font-medium text-gray-900">Tipo de moneda y valor</dt>
          <dd class="text-right text-gray-700 sm:col-span-2">
            {{
              (transaccionService.statePlaceToPayData().data?.payment
                ? transaccionService.statePlaceToPayData().data?.payment[transaccionService.statePlaceToPayData().data?.payment.length - 1]?.amount?.from?.total
                : '0'
              ) | currency: 'COP $' : 'symbol':'1.0-0'
            }}
          </dd>
        </div>
      }

      <div class="grid grid-cols-1 gap-1 py-1 sm:grid-cols-3 sm:gap-4">
        <dt class="font-medium text-gray-900">Descripción</dt>
        <dd class="text-right text-gray-700 sm:col-span-2">
          {{ transaccionService.statePlaceToPayData().data?.request.payment
            ? transaccionService.statePlaceToPayData().data?.request.payment.description
            : transaccionService.statePlaceToPayData().data?.request.subscription.description
          }}
        </dd>
      </div>

      <div class="grid grid-cols-1 gap-1 py-1 sm:grid-cols-3 sm:gap-4">
        <dt class="font-medium text-gray-900">Nombre del comprador o cliente</dt>
        <dd class="text-right capitalize text-gray-700 sm:col-span-2">
          {{ transaccionService.statePlaceToPayData().data?.request.buyer.name }}
          {{ transaccionService.statePlaceToPayData().data?.request.buyer.surname }}
        </dd>
      </div>

      <div class="grid grid-cols-1 gap-1 py-1 sm:grid-cols-3 sm:gap-4">
        <dt class="font-medium text-gray-900">Dirección IP</dt>
        <dd class="text-right capitalize text-gray-700 sm:col-span-2">
          {{ transaccionService.statePlaceToPayData().data?.request.ipAddress }}
        </dd>
      </div>

      @if (this.transaccionService.statePlaceToPayData().data?.status.status !== 'PENDING') {
        <div class="grid grid-cols-1 gap-1 py-1 sm:grid-cols-3 sm:gap-4">
          <dt class="font-medium text-gray-900">Consulta</dt>
          <dd class="text-justify text-gray-700 sm:col-span-2">
            Para obtener más información acerca de la transacción, puede comunicarse a la línea <strong>{{ parametroService.faqPlaceToPayTelefonoComercio().valor }}</strong>
            o enviar un mensaje al correo electrónico <strong>{{ parametroService.faqPlaceToPayEmailComercio().valor }}</strong>
          </dd>
        </div>
      }

    </dl>
  </div>
  @if (this.transaccionService.statePlaceToPayData().data?.status.status === 'PENDING') {
    <div class="flex flex-col items-center">
      <p class="text-sm text-justify italic">
        Por favor espere unos minutos y vuelva a consultar más tarde para verificar si su pago fue confirmado de forma exitosa. 
        Si desea más información sobre el estado actual de su operación puede enviar un correo electrónico a <strong>{{ parametroService.faqPlaceToPayEmailComercio().valor }}</strong>
        y preguntar por el estado de la transacción:&nbsp;
        {{
          transaccionService.statePlaceToPayData().data?.payment
            ? transaccionService.statePlaceToPayData().data?.payment[transaccionService.statePlaceToPayData().data?.payment.length - 1].authorization
            : ''
        }}.
      </p>
    </div>
  }
  } @else {
    <div class="flex flex-col items-center">
      <p>
        <i class="pi pi-clock text-gray-500" style="font-size: 2rem"></i>
      </p>
      <p class="text-xl font-semibold text-gray-500" >
        Transacción en proceso
      </p>
      <span class="text-sm">Por favor espere unos minutos</span> 
      <p class="text-sm text-justify px-2 sm:px-10 py-10">
        <span onclick=" location.reload()" class="font-bold text-primary-500 cursor-pointer">Actualiza la página dando clic aquí <i class="pi pi-refresh" style="font-size: 0.8rem; font-weight: 600;"></i></span> y consulta el listado de movimientos. 
        En caso de tener problemas con la operación, puedes enviar un correo electrónico a <strong>{{ parametroService.faqPlaceToPayEmailComercio().valor }}</strong>
        y preguntar por el estado de la transacción.
      </p>
    </div>
  }  
</p-dialog>
<p-dialog
    [closable]="false"
    [(visible)]="visibleConfirmacionCompra"
    [styleClass]="'lg:w-[24rem] border-b-4 border-primary-500 mx-4'"
    [draggable]="false"
    [modal]="true"
    [resizable]="false" >
    <ng-template pTemplate="header">
        <div class="flex flex-col items-center w-full">
            <img src="assets/icons/tolis/TOLIS_Icon Display_Facturas_afirmacion.svg" class="h-12 w-12">
            <p class="text-center text-lg font-bold lg:text-2xl mt-2">¡Gracias por tu compra!</p>
        </div>
    </ng-template>
    <ng-template pTemplate="body">
        <div class="flex flex-col items-center justify-center">
            <p class="text-center text-sm lg:text-base">Te enviaremos actualizaciones sobre el estado del envío del <span class="font-bold">Tag</span> al correo electrónico registrado.
            Una vez lo recibas, podrás vincularlo a tu vehículo y comenzar a pagar tus peajes de forma rápida y segura con Tag.</p>
        </div>
    </ng-template>
    <ng-template pTemplate="footer">
        <div class="flex justify-center mt-4">
            <button class="btn-primary" type="button" (click)="visibleConfirmacionCompra=false">Aceptar</button>
        </div>
    </ng-template>
</p-dialog>